var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getPermission.settings.view)?_c('div',[_c('md-tabs',{staticClass:"load-and-stage-tabs",attrs:{"md-sync-route":""}},[_c('md-tab',{attrs:{"id":"tab-load","md-label":"Loads","to":"/gstLoadAndStage/gstLoads"}}),_c('md-tab',{attrs:{"id":"tab-stage","md-label":"Stages","to":"/gstLoadAndStage/gstStages"}})],1),_c('router-view')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }